import React from 'react';
import { useDynamicWidgets, UseDynamicWidgetsProps } from 'react-instantsearch';
import { colorSwatchKey } from '../../hooks/useColorSwatches';
import { VirtualRefinementList } from './VirtualRefinementList';
import { FACET_TYPES } from '../../constants';
import { VirtualToggleRefinement } from './VirtualToggleRefinement';
import { VirtualRange } from './VirtualRange';

export const VirtualFacets: React.FC<UseDynamicWidgetsProps> = (props) => {
    const { attributesToRender: allAttributes } = useDynamicWidgets({
        maxValuesPerFacet: 1000,
        facets: ['*'],
        ...props,
    });

    return (
        <>
            <VirtualToggleRefinement attribute={FACET_TYPES.OFFERS} />
            <VirtualToggleRefinement attribute={FACET_TYPES.MEMBERS_OFFER} />

            <VirtualRefinementList attribute={FACET_TYPES.STORE} />
            <VirtualToggleRefinement attribute={FACET_TYPES.STORE_WEB} />

            <VirtualRange attribute={FACET_TYPES.EFFECTIVE_PRICE} />

            {allAttributes.map((attribute) => {
                switch (attribute) {
                    case colorSwatchKey:
                        return null;

                    case FACET_TYPES.SOLE_REPRESENTATION:
                    case FACET_TYPES.IS_NEW:
                    case FACET_TYPES.ALLERGY_FRIENDLY:
                    case FACET_TYPES.PERSONALIZATION:
                        return <VirtualToggleRefinement key={attribute} attribute={attribute} />;

                    default:
                        return <VirtualRefinementList key={attribute} attribute={attribute} />;
                }
            })}
        </>
    );
};
